import css from "./primitives.module.css";

type SpriteProps = {
  /** A blob URL from design/sprites. */
  src: string;
  /**
   * §5: "displayed at an integer multiple" of the 20px (or 12px icon) grid.
   * The listed sizes are 44/52/68/86/92/104/116/120/130/132/150/180/220.
   */
  size: number;
  /**
   * §10: "Sprites are decorative (alt='') except tier badge and file-type
   * icons, which carry names." Passing a label makes it an img with that name;
   * omitting it hides the sprite from assistive tech entirely.
   */
  label?: string;
  className?: string;
};

export function Sprite({ src, size, label, className }: SpriteProps) {
  return (
    <div
      className={className ? `${css.sprite} ${className}` : css.sprite}
      style={{ width: size, height: size, backgroundImage: `url('${src}')` }}
      {...(label
        ? { role: "img", "aria-label": label }
        : { role: "presentation", "aria-hidden": true })}
    />
  );
}
